import { groupPeopleByFloor } from "@lib/logic";
import { getFloorsByBuildingId, useAppSelector } from "@lib/store";
import { useRequiredContext } from "@lib/utils";

import { HaNContext } from "../shell/HaNContext";

/** The people in the building today: those on the selected floor, and those on each other floor. */
export const usePeopleModel = () => {
  const { isTabLoading, building, floor, people } = useRequiredContext(HaNContext);
  const floors = useAppSelector(state => getFloorsByBuildingId(state, building.buildingId ?? ""));

  const { onSelectedFloor, otherFloors } = groupPeopleByFloor({
    reservations: people.reservations,
    floorIds: floors.map(({ id }) => id),
    selectedFloorId: floor.floorId,
  });

  return {
    isLoading: isTabLoading,
    isFailed: people.status === "failed",
    retry: people.retry,
    onSelectedFloor,
    otherFloors,
  };
};
